import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { selectOptionalUser } from 'features/auth/store/authSelectors';
import { useReportLoading } from 'features/loading';
import { logger } from 'features/logger/logger';
import { useAppSelector } from 'features/store/hooks';
import { useSetUrlLocale } from './useSetUrlLocale';

export const ProtectedRoutes = () => {
  const user = useAppSelector(selectOptionalUser);
  const localeInitialized = useSetUrlLocale();

  useReportLoading(!user || !localeInitialized);

  if (!user) {
    logger.debug(`ProtectedRoutes wrapper, user is not signed in`);
    return null;
  }
  if (!localeInitialized) return null;

  return (
    <Box component="main" sx={{ height: '100%' }}>
      <Outlet />
    </Box>
  );
};
